import React from 'react';
import { ArrowRight } from 'lucide-react';
import { photos } from '../photos';

export default function Hero({ t }) {
  const h = t.hero;

  return (
    <section className="relative min-h-[100svh] flex flex-col justify-end overflow-hidden bg-ink text-snow">
      <img
        src={photos.hero}
        alt={t.media.hero}
        className="absolute inset-0 w-full h-full object-cover animate-scale-in"
      />
      <div className="absolute inset-0 bg-mesh" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/55 to-ink/25" />

      <div className="relative max-w-[1440px] w-full mx-auto px-5 sm:px-8 lg:px-12 xl:px-16 pt-[110px] pb-14 lg:pb-20">
        <p className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-[-0.04em] font-bold animate-fade-up">
          Fit<span className="text-volt">AI</span>365
        </p>

        <h1 className="mt-6 font-display font-bold uppercase leading-[0.9] tracking-[-0.03em] max-w-4xl animate-fade-up [animation-delay:120ms]">
          <span className="block text-5xl sm:text-7xl lg:text-8xl">{h.line1}</span>
          <span className="block text-5xl sm:text-7xl lg:text-8xl text-volt">{h.line2}</span>
          <span className="block text-5xl sm:text-7xl lg:text-8xl text-snow/35">{h.line3}</span>
        </h1>

        <p className="mt-6 text-base sm:text-lg text-snow/80 max-w-xl leading-relaxed animate-fade-up [animation-delay:220ms]">
          {h.sub}
        </p>

        <div className="mt-8 flex flex-wrap items-center gap-3 animate-fade-up [animation-delay:320ms]">
          <a
            href="/s"
            className="inline-flex items-center gap-2 px-7 py-4 bg-volt text-ink font-bold uppercase tracking-[0.12em] text-sm hover:bg-snow transition-colors duration-200"
          >
            {h.cta}
            <ArrowRight size={18} strokeWidth={2.5} />
          </a>
          <a
            href="#platform"
            className="inline-flex items-center gap-2 px-7 py-4 border border-snow/35 text-snow font-bold uppercase tracking-[0.12em] text-sm hover:bg-snow hover:text-ink transition-colors duration-200"
          >
            {h.ctaSecondary}
          </a>
        </div>
      </div>

      <div className="relative border-t border-white/10 bg-ink/80 backdrop-blur-sm">
        <div className="max-w-[1440px] mx-auto grid grid-cols-3">
          {h.stats.map((s, i) => (
            <div key={s.label} className={`px-4 sm:px-8 py-6 sm:py-8 ${i > 0 ? 'border-l border-white/10' : ''}`}>
              <p className="font-display text-3xl sm:text-5xl uppercase leading-none tracking-tight">{s.value}</p>
              <p className="mt-2 text-[11px] sm:text-xs uppercase tracking-[0.14em] text-snow/65">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
